export const DEFAULT_FILE_TO_OPEN_UUID = '24c070a4-db57-45d0-ecbd-cd31d91e3471';
